<template>
  <div class="employee">
    <CCard class="card-table-emloyee">
      <CRow>
        <CCol sm="6">
          <div class="form-group">
            <label>{{
              $t("placeholder.label_employee_search_code_name")
            }}</label>
            <CInput
              v-model="searchData.name"
              :placeholder="
                this.$t('placeholder.label_employee_search_code_name')
              "
              v-on:keyup.enter="search"
            />
          </div>
        </CCol>
        <CCol sm="6">
          <div class="form-group">
            <label>
              {{ $t("placeholder.label_employee_search_work_type") }}
            </label>
            <CInput
              v-model="searchData.work_type"
              :placeholder="
                this.$t('placeholder.label_employee_search_work_type')
              "
              v-on:keyup.enter="search"
            />
          </div>
        </CCol>
      </CRow>
      <CRow>
        <CCol sm="4">
          <div class="form-group">
            <label>{{ $t("employee.label_employee_job_title") }}</label>
            <select
              class="form-control"
              v-model="searchData.job_title_code"
              @change="search"
            >
              <option value="0">
                {{ $t("placeholder.label_employee_option_search") }}
              </option>
              <option
                :value="item.code"
                v-for="(item, index) in jobTitle"
                :key="index"
                >{{ item.name }}</option
              >
            </select>
          </div>
        </CCol>
        <CCol sm="4">
          <div class="form-group">
            <label>{{ $t("employee.label_company_name") }}</label>
            <select
              class="form-control"
              v-model="searchData.company_code"
              @change="search"
            >
              <option value="0">
                {{ $t("placeholder.label_employee_option_search") }}
              </option>
              <option
                :value="key"
                v-for="(item, key, index) in companies"
                :key="index"
                >{{ item.name }}</option
              >
            </select>
          </div>
        </CCol>
        <CCol sm="4">
          <div class="form-group">
            <label>
              {{ $t("employee.label_employee_language_certificate") }}
            </label>
            <select
              class="form-control"
              v-model="searchData.japanese_level"
              @change="search"
            >
              <option value="-1">
                {{ $t("placeholder.label_employee_option_search") }}
              </option>
              <option
                :value="item.id"
                v-for="(item, index) in japaneseLevel"
                :key="index"
                >{{ item.name }}</option
              >
            </select>
          </div>
        </CCol>
      </CRow>
      <CRow>
        <CCol sm="4">
          <div class="form-group">
            <label>{{ $t("employee.label_employee_foot") }}</label>
            <select
              class="form-control"
              v-model="searchData.footCode"
              @change="search"
            >
              <option value="0">
                {{ $t("placeholder.label_employee_option_search") }}
              </option>
              <option
                :value="item.code"
                v-for="(item, index) in foots"
                :key="index"
                >{{ item.name }}</option
              >
            </select>
          </div>
        </CCol>
        <CCol sm="4">
          <div class="form-group">
            <label>{{ $t("employee.label_employee_division") }}</label>
            <select
              class="form-control"
              v-model="searchData.divisionCode"
              @change="search"
            >
              <option value="0">
                {{ $t("placeholder.label_employee_option_search") }}
              </option>
              <option
                :value="item.code"
                v-show="
                  item.parent_code === searchData.footCode ||
                    searchData.footCode == 0
                "
                v-for="(item, index) in divisions"
                :key="index"
                >{{ item.name }}</option
              >
            </select>
          </div>
        </CCol>
        <CCol sm="4">
          <div class="form-group">
            <label>{{ $t("employee.label_employee_position") }}</label>
            <select
              class="form-control"
              v-model="searchData.positionId"
              @change="search"
            >
              <option value="0">
                {{ $t("placeholder.label_employee_option_search") }}
              </option>
              <option
                :value="item.id"
                v-for="(item, index) in positions"
                :key="index"
                >{{ item.name }}</option
              >
            </select>
          </div>
        </CCol>
      </CRow>
      <CRow>
        <CCol sm="12" class="text-center btn-search">
          <CButton class="btn-search-employee" @click.prevent="search">{{
            $t("button.label_employee_btn_search")
          }}</CButton>
          <CButton class="btn-reset" @click="resetForm">{{
            $t("button.label_action_reset")
          }}</CButton>
        </CCol>
      </CRow>
    </CCard>
    <CRow>
      <CCol sm="12">
        <CCard class="employee-table">
          <CCardBody>
            <div class="option-table">
              <div class="form-group">
                <select
                  class="form-control select-per-page mr-4"
                  v-model="searchData.itemsPerPage"
                  @change="search"
                >
                  <option
                    v-for="(item, index) in listItemsPerPage"
                    :value="item"
                    :key="index"
                    >{{ item }}</option
                  >
                </select>
              </div>

              <div
                class="show-text-table log-action"
                v-if="logAction && Object.keys(logAction).length > 0"
              >
                {{ logAction.created_by }}
                {{ $t("logAction." + logAction.type_of_action) }}
                {{ formatDateOverTime(logAction.updated_at) }}
              </div>

              <template v-if="employees.data && employees.data.length > 0">
                <div class="show-text-table">
                  {{ $t("commons.label_text_show") }}
                  {{ searchData.paginate.from }}
                  {{ $t("commons.label_text_to") }}
                  {{ searchData.paginate.to }}
                  {{ $t("commons.label_text_of") }}
                  {{ searchData.paginate.totalRecord }}
                  {{ $t("commons.label_text_entries") }}
                </div>
              </template>
              <template v-else>
                <div class="show-text-table">
                  {{ $t("commons.label_text_show") }}
                  {{ searchData.paginate.from }}
                  {{ searchData.paginate.to }}
                  {{ searchData.paginate.totalRecord }}
                  {{ $t("commons.label_text_entries") }}
                </div>
              </template>
            </div>
            <div class="table-responsive">
              <table class="table table-mobile table-tablet">
                <thead>
                  <tr>
                    <th>#</th>
                    <th @click="sortByColumn(columnSort.id)" class="cl-pointer">
                      {{ $t("employee.label_employee_code") }}
                      <span class="icon-sort">
                        <CIcon
                          name="cil-caret-bottom"
                          :class="classStatusSort('id')"
                        ></CIcon>
                      </span>
                    </th>
                    <th
                      scope="col"
                      @click="sortByColumn(columnSort.name)"
                      class="cl-pointer"
                    >
                      {{ $t("employee.label_employee_name") }}
                      <span class="icon-sort">
                        <CIcon
                          name="cil-caret-bottom"
                          :class="classStatusSort('name')"
                        ></CIcon>
                      </span>
                    </th>
                    <th
                      scope="col"
                      @click="sortByColumn(columnSort.join_date)"
                      class="cl-pointer"
                    >
                      {{ $t("employee.label_employee_date_start") }}
                      <span class="icon-sort">
                        <CIcon
                          name="cil-caret-bottom"
                          :class="classStatusSort('join_date')"
                        ></CIcon>
                      </span>
                    </th>
                    <th
                      scope="col"
                      @click="sortByColumn(columnSort.company_code)"
                      class="cl-pointer"
                    >
                      {{ $t("employee.label_company_name") }}
                      <span class="icon-sort">
                        <CIcon
                          name="cil-caret-bottom"
                          :class="classStatusSort('company_code')"
                        ></CIcon>
                      </span>
                    </th>
                    <th
                      scope="col"
                      @click="sortByColumn(columnSort.job_title_code)"
                      class="cl-pointer"
                    >
                      {{ $t("employee.label_employee_job_title") }}
                      <span class="icon-sort">
                        <CIcon
                          name="cil-caret-bottom"
                          :class="classStatusSort('job_title_code')"
                        ></CIcon>
                      </span>
                    </th>
                    <th scope="col">
                      {{ $t("employee.label_employee_foot") }}
                    </th>
                    <th
                      scope="col"
                      @click="sortByColumn(columnSort.division_code)"
                      class="cl-pointer"
                    >
                      {{ $t("employee.label_employee_division") }}
                      <span class="icon-sort">
                        <CIcon
                          name="cil-caret-bottom"
                          :class="classStatusSort('division_code')"
                        ></CIcon>
                      </span>
                    </th>
                    <th
                      scope="col"
                      @click="sortByColumn(columnSort.position_id)"
                      class="cl-pointer"
                    >
                      {{ $t("employee.label_employee_position") }}
                      <span class="icon-sort">
                        <CIcon
                          name="cil-caret-bottom"
                          :class="classStatusSort('position_id')"
                        ></CIcon>
                      </span>
                    </th>
                    <th scope="col">
                      {{ $t("employee.label_employee_level") }}
                    </th>
                    <th
                      scope="col"
                      @click="sortByColumn(columnSort.work_type)"
                      class="cl-pointer"
                    >
                      {{ $t("employee.label_employee_work_type") }}
                      <span class="icon-sort">
                        <CIcon
                          name="cil-caret-bottom"
                          :class="classStatusSort('work_type')"
                        ></CIcon>
                      </span>
                    </th>

                    <th
                      scope="col"
                      @click="sortByColumn(columnSort.number_of_days_leave)"
                      class="cl-pointer"
                    >
                      Số ngày nghỉ
                      <span class="icon-sort">
                        <CIcon
                          name="cil-caret-bottom"
                          :class="classStatusSort('number_of_days_leave')"
                        ></CIcon>
                      </span>
                    </th>

                    <th scope="col">
                      {{ $t("employee.label_employee_work_shift") }}
                    </th>

                    <th scope="col" class="text-center">
                      {{ $t("employee.label_employee_action") }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <template v-if="employees.data && employees.data.length > 0">
                    <tr v-for="(item, index) in employees.data" :key="index">
                      <th scope="row">
                        {{
                          (employees.current_page - 1) * employees.per_page +
                            index +
                            1
                        }}
                      </th>
                      <td>{{ item.id }}</td>
                      <td>
                        <router-link
                          :to="{
                            name: 'employees.detail',
                            params: { id: item.id }
                          }"
                          tag="a"
                          >{{ item.name }}</router-link
                        >
                      </td>
                      <td>{{ item.join_date | formatDate }}</td>
                      <td>{{ item.company_name }}</td>
                      <td>{{ item.job_title_name }}</td>
                      <td>{{ item.foot }}</td>
                      <td>{{ item.division }}</td>
                      <td>{{ item.position_name }}</td>
                      <td>{{ item.level_name ? item.level_name : "" }}</td>
                      <td>{{ item.work_type }}</td>
                      <td>{{ item.number_of_days_leave }}</td>
                      <td>
                        {{
                          [
                            formatShift(item.work_shift.morning_shift_start, item.work_shift.morning_shift_end),
                            formatShift(item.work_shift.afternoon_shift_start, item.work_shift.afternoon_shift_end)
                          ].join(' && ') 
                        }}
                      </td>
                      <td class="py-2 d-flex justify-content-center">
                        <CButton
                          id="toggle-btn"
                          class="btn-sm"
                          variant="outline"
                          @click="showModalNote(item.id)"
                          color="primary"
                          square
                          >{{
                            $t("button.label_employee_note_button")
                          }}</CButton
                        >
                        <span class="mr-1"></span>
                        <router-link
                          class="btn btn-primary btn-sm"
                          :to="{ path: `/employees/update/${item.id}` }"
                          >{{ $t("button.label_action_edit") }}</router-link
                        >
                        <span class="mr-1"></span>
                        <CButton
                          class="btn-sm"
                          color="primary"
                          variant="outline"
                          square
                          size="sm"
                          @click.prevent="deleteEmp(item.id)"
                          >{{ $t("button.label_action_delete") }}</CButton
                        >
                      </td>
                    </tr>
                  </template>
                  <template v-else>
                    <tr>
                      <td colspan="12" class="text-center">
                        {{ $t("table.label_data_not_found") }}
                      </td>
                    </tr>
                  </template>
                </tbody>
              </table>
            </div>
          </CCardBody>
          <CPagination
            :activePage.sync="searchData.paginate.currentPage"
            :pages="searchData.paginate.totalPage"
            @update:activePage="changePage"
            size="sm"
            align="center"
          />
        </CCard>
      </CCol>
    </CRow>

    <!--modal note-->
    <template>
      <b-modal ref="modal-note" hide-footer hide-header>
        <ValidationObserver ref="formResignation" v-slot="{ handleSubmit }">
          <CForm @submit.prevent="handleSubmit(createNote)">
            <CRow>
              <CCol md="12" class="form-field">
                <label>
                  {{ $t("employee.label_employee_note") }}
                  <span class="require">*</span>
                </label>
                <ValidationProvider
                  rules="required|min:10|max:500"
                  v-slot="{ errors }"
                  :name="$t('employee.label_employee_note')"
                >
                  <b-form-textarea
                    v-model="formNote.note"
                    rows="4"
                  ></b-form-textarea>
                  <span class="required">{{ errors[0] }}</span>
                </ValidationProvider>
              </CCol>
            </CRow>
            <CRow class="d-flex justify-content-end mr-1">
              <b-button type="submit" class="btn btn-success mt-3">
                {{ $t("button.label_action_accept") }}
              </b-button>
              <span class="mr-2"></span>
              <b-button
                class="mt-3"
                variant="outline-danger"
                @click="hideModalNote"
                >{{ $t("button.label_action_cancel") }}</b-button
              >
            </CRow>
          </CForm>
        </ValidationObserver>
      </b-modal>
    </template>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import moment from "moment";

export default {
  name: "EmployeeIndex",
  metaInfo() {
    return {
      title: this.$t("page_title.page_employee_list"),
      titleTemplate: "%s | " + this.$t("page_title.head_title")
    };
  },
  components: {
    ValidationProvider,
    ValidationObserver
  },
  data() {
    return {
      searchData: {
        name: "",
        work_type: "",
        job_title_code: 0,
        company_code: 0,
        japanese_level: -1,
        footCode: 0,
        divisionCode: 0,
        positionId: 0,
        itemsPerPage: 10,
        columnSortSelect: "id",
        sortBy: "DESC",
        paginate: {
          from: 0,
          to: 0,
          totalPage: 0,
          path: "",
          currentPage: 1,
          totalRecord: 0,
          perPage: 0
        }
      },
      formNote: {
        employeeId: null,
        note: null
      },
      iconSort: {
        id: false,
        name: false,
        join_date: false
      },
      columnSort: {
        id: "id",
        name: "name",
        join_date: "join_date",
        company_code: "company_code",
        job_title_code: "job_title_code",
        division_code: "division_code",
        position_id: "position_id",
        level: "level",
        work_type: "work_type",
        number_of_days_leave: "number_of_days_leave"
      }
    };
  },
  computed: {
    ...mapGetters({
      employees: "employee/employees",
      foots: "commons/foots",
      divisions: "commons/divisions",
      positions: "commons/positions",
      jobTitle: "commons/jobTitle",
      japaneseLevel: "commons/japaneseLevel",
      companies: "commons/companies",
      listItemsPerPage: "commons/listItemsPerPage",
      sort: "commons/sort",
      pagination: "employee/pagination",
      logAction: "employee/logAction"
    })
  },
  methods: {
    ...mapActions("employee", ["fetchEmployee", "deleteEmployee"]),
    ...mapActions("layout", ["setLoading"]),

    formatDateOverTime(value) {
      if (value) {
        return moment(String(value)).format("DD/MM/YYYY HH:mm:ss");
      }
    },
    showModalNote(employeeId) {
      this.$refs["modal-note"].show();
      this.formNote.employeeId = employeeId;
    },
    hideModalNote() {
      this.$refs["modal-note"].hide();
    },

    async fetchEmployeesData() {
      await this.fetchEmployee({
        optionPage: this.searchData.itemsPerPage,
        currentPage: this.searchData.paginate.currentPage,
        columnSort: this.searchData.columnSortSelect,
        sortBy: this.searchData.sortBy,
        name: this.searchData.name.toLowerCase(),
        work_type: this.searchData.work_type.toLowerCase(),
        job_title_code: this.searchData.job_title_code,
        company_code: this.searchData.company_code,
        japanese_level: parseInt(this.searchData.japanese_level),
        footCode: this.searchData.footCode,
        divisionCode: this.searchData.divisionCode,
        positionId: parseInt(this.searchData.positionId)
      });
      this.searchData.paginate = this.pagination;
    },

    async search() {
      if (this.$route.fullPath !== "/employees") {
        this.clearParamUrl();
      }
      this.passParamUrl();
      this.setLoading(true);
      try {
        await this.fetchEmployeesData();
        this.setLoading(false);
      } catch {
        this.setLoading(false);
      }
    },

    resetParams() {
      if (this.$route.fullPath !== "/employees") {
        this.clearParamUrl();
      }
      this.searchData = {
        name: "",
        work_type: "",
        job_title_code: 0,
        company_code: 0,
        japanese_level: -1,
        footCode: 0,
        divisionCode: 0,
        positionId: 0,
        itemsPerPage: 10,
        columnSortSelect: "id",
        sortBy: "DESC",
        paginate: {
          from: 0,
          to: 0,
          totalPage: 0,
          path: "",
          currentPage: 1,
          totalRecord: 0,
          perPage: 0
        }
      };
    },

    resetForm() {
      (this.searchData.name = ""),
        (this.searchData.work_type = ""),
        (this.searchData.job_title_code = 0),
        (this.searchData.company_code = 0),
        (this.searchData.japanese_level = -1);
      (this.searchData.footCode = 0),
        (this.searchData.divisionCode = 0),
        (this.searchData.positionId = 0);
    },

    passParamUrl() {
      this.$router.push({
        name: "employees",
        query: {
          name: this.checkDataParam(this.searchData.name),
          workType: this.checkDataParam(this.searchData.work_type),
          jobTitleCode: this.checkDataParam(this.searchData.job_title_code),
          companyCode: this.checkDataParam(this.searchData.company_code),
          japaneseLevel: this.checkDataParam(this.searchData.japanese_level),
          footCode: this.checkDataParam(this.searchData.footCode),
          divisionCode: this.checkDataParam(this.searchData.divisionCode),
          positionId: this.checkDataParam(this.searchData.positionId),
          columnSort: this.checkDataParam(this.searchData.columnSortSelect),
          sortBy: this.checkDataParam(this.searchData.sortBy),
          currentPage: this.checkDataParam(
            this.searchData.paginate.currentPage
          ),
          perPage: this.checkDataParam(this.searchData.itemsPerPage)
        }
      });
    },

    clearParamUrl() {
      this.$router.push({ name: "employees" });
    },

    sortByColumn(column) {
      if (this.searchData.columnSortSelect != column) {
        this.searchData.sortBy = "DESC";
      }
      this.searchData.columnSortSelect = column;
      this.searchData.sortBy =
        this.searchData.sortBy === "DESC" ? "ASC" : "DESC";
      this.passParamUrl();
      this.fetchEmployeesData();
    },
    classStatusSort(column) {
      return this.searchData.columnSortSelect === column &&
        this.searchData.sortBy === "ASC"
        ? "sort-rotate"
        : "";
    },

    changePage(page) {
      this.passParamUrl();
      this.fetchEmployeesData(this.searchData.itemsPerPage, page);
    },

    checkDataParam(data) {
      return data === 0 || data === "" ? undefined : data;
    },

    async deleteEmp(employeeId) {
      this.$confirm(
        this.$t("popup.label_popup_text"),
        this.$t("popup.label_popup_title"),
        this.$t("popup.label_confirm_button"),
        this.$t("popup.label_cancel_button"),
        "danger"
      ).then(value => {
        if (value) {
          this.deleteEmployee(employeeId)
            .then(() => {
              this.fetchEmployeesData();
              this.$toast(
                this.$t("popup.label_popup_success_text"),
                null,
                2000,
                "b-toaster-top-center",
                "success"
              );
            })
            .catch(() => {
              this.$toast(
                this.$t("popup.label_popup_error_text"),
                null,
                2000,
                "b-toaster-top-center",
                "error"
              );
            });
        }
      });
    },

    async createNote() {
      this.setLoading(true);
      await this.$store
        .dispatch("employee/createNoteEmployee", this.formNote)
        .then(() => {
          this.setLoading(false);
          this.hideModalNote();
          this.formNote = {};
          this.$toast(
            this.$t("popup.lable_popup_create_note_success"),
            null,
            2000,
            "b-toaster-top-center",
            "success"
          );
        })
        .catch(() => {
          this.setLoading(false);
          this.hideModalNote();
          this.formNote = {};
        });
    },

    formatShift(start, end) {
      return `${start.slice(0,5)}->${end.slice(0,5)}`;
    }
  },
  created() {
    if (Object.keys(this.$route.query).length !== 0) {
      let params = this.$route.query;
      params.perPage =
        this.listItemsPerPage.includes(parseInt(params.perPage)) &&
        !isNaN(params.perPage)
          ? params.perPage
          : 10;
      params.sortBy = this.sort.includes(params.sortBy)
        ? params.sortBy
        : "DESC";
      this.searchData = {
        name: params.name == undefined ? this.searchData.name : params.name,
        work_type:
          params.workType == undefined
            ? this.searchData.work_type
            : params.workType,
        job_title_code:
          params.jobTitleCode == undefined
            ? this.searchData.job_title_code
            : params.jobTitleCode,
        company_code:
          params.companyCode == undefined
            ? this.searchData.company_code
            : params.companyCode,
        japanese_level:
          params.japaneseLevel == undefined
            ? this.searchData.japanese_level
            : params.japaneseLevel,
        footCode:
          params.footCode == undefined
            ? this.searchData.footCode
            : params.footCode,
        divisionCode:
          params.divisionCode == undefined
            ? this.searchData.divisionCode
            : params.divisionCode,
        positionId:
          params.positionId == undefined
            ? this.searchData.positionId
            : params.positionId,
        itemsPerPage: params.perPage,
        columnSortSelect: params.columnSort,
        sortBy: params.sortBy,
        paginate: {
          from: params.from,
          to: params.to,
          totalPage: parseInt(params.totalPage),
          path: this.searchData.paginate.path,
          currentPage: parseInt(params.currentPage),
          totalRecord: parseInt(params.totalRecord),
          perPage: parseInt(params.perPage)
        }
      };
    }
    this.fetchEmployeesData();
  },
  watch: {
    $route(to) {
      if (to.fullPath === "/employees") {
        this.resetParams();
        this.fetchEmployeesData();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.employee {
  margin: -2rem -30px 30px -30px;
  .card-table-emloyee {
    padding: 30px;
  }
  .btn-search-employee {
    background-color: #b5dbf2;
    padding: 8px;
    width: 120px;
  }
  .employee-table {
    margin: 0 20px 0 30px;
    .cl-pointer {
      cursor: pointer;
      .icon-sort {
        margin-left: 5px;
        .c-icon {
          width: 12px;
        }
        .sort-rotate {
          transform: rotate(180deg);
        }
      }
    }
  }
  .select-per-page {
    width: 70px;
  }
  .option-table {
    display: flex;
    justify-content: space-between;
    .log-action {
      margin-left: auto;
      margin-right: 20px;
    }
  }
  .btn-search {
    margin-top: 15px;
  }
}
.require {
  color: #ff1a1a;
}
th,
td {
  vertical-align: middle !important;
}
@media only screen and (max-device-width: 767px) {
  .employee .employee-table {
    margin: 0 20px;
  }
  .table-mobile {
    width: 1500px;
    overflow-x: scroll;
  }
}
@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) {
  .employee .employee-table {
    margin: 1rem;
  }
  .table-tablet {
    width: 1500px;
    overflow-x: scroll;
  }
}
</style>